import { BlueprintDataSource } from '@leverege/molten-core';
import React from 'react';
import { Attributes } from '@leverege/ui-attributes';
import ParentUtil from "./ParentUtil.js";
import ParentSelector from "./ParentSelector.js";
import { jsx as _jsx } from "react/jsx-runtime";
const EMPTY = {};
function ParentRelationshipCustomTextRenderer(props) {
  const {
    value,
    object,
    model
  } = props;
  const {
    relationship
  } = BlueprintDataSource.getRelationship(object) || EMPTY;
  const attribute = Attributes.getAttribute(model.attrName, model.objectType);
  const parentAction = ParentUtil.getParentAction(object, attribute);
  return /*#__PURE__*/_jsx(ParentSelector, {
    editable: false,
    attribute: attribute,
    parentAction: parentAction,
    relationship: relationship,
    value: value,
    raw: true
  });
}
export default {
  id: 'molten.CustomTextValueRenderer.parentRelationship',
  valueType: 'parentRelationship',
  Component: ParentRelationshipCustomTextRenderer
};